
import { Request } from "@/api/request";
import { defineComponent, ref, inject, onMounted, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { storeUser } from "@/store/User";
export default defineComponent({
    name: "VipClass",
    setup() {
        const Router = useRouter();
        const Route = useRoute();
        const setTitle: any = inject("setTitle"),
            headClass = inject("headClass");
        setTitle(["运营管理", "尊享卡项目"]);
        let user = storeUser.getUser();
        let form: any = ref({
                class_name: "",
                number:"",
                work_hour_fee:"",
                percentage_type:"",
                percentage:"",
                id:""
            }),
            pageSize = ref(10),
            total = ref(0),
            currentPage = ref(1),
			commissionType = ref(["固定金额", "业绩比例"]),
            formRef: any = ref(null),
            tableData = ref([[], []] as any),
            loading = ref(false),
            vip_card_id: any = ref(0);
        const rules: any = ref({
            class_name: [
                {
                    required: true,
                    message: "请输入尊享卡项目名称",
                    trigger: "blur",
                },
            ],
            number: [
                {
                    required: true,
                    message: "请输入尊享卡项目服务次数",
                    trigger: "blur",
                },
            ],
            work_hour_fee: [
                {
                    required: true,
                    message: "请输入项目工时费",
                    trigger: "blur",
                },
            ],
        });
        let edit = (data: any) => {
                if(formRef.value){
                    (formRef.value as any).resetFields();
                }
                //form.value = data;
                form.value = {
                    class_name: data.class_name,
                    number:data.number,
                    work_hour_fee:data.work_hour_fee,
                    percentage_type:data.percentage_type,
                    percentage:data.percentage,
                    id:data.id
                };
                console.log(data);
                dialogVisible.value = true;
                dialogType.value = 2;
            },
            add = (data: any) => {
                if(formRef.value){
                    (formRef.value as any).resetFields();
                }
                form.value = {
                    class_name: "",
                    number:"",
                    work_hour_fee:"",
                    percentage_type:"",
                    percentage:"",
                    id:""
                };
                dialogVisible.value = true;
                dialogType.value = 1;
            },
            dialogVisible = ref(false),
            dialogType = ref(1);
        // 获取项目列表
        let getVipCardList = () => {
                loading.value = true;
                Request.axiosInstance({
                    url: "adminapi/VipClass/list",
                    data: {
						vip_card_id,
                        page:currentPage.value,
                        pagesize:pageSize.value
					},
                }).then((res: any) => {
                    loading.value = false;
                    tableData.value = res?.content?.list || [];
                    total.value = res?.content?.total || 0;
                });
            },
            setVipCardClassState = (
                status: number,
                class_id: string,
                index: number
            ) => {
                if (class_id) {
                    Request.axiosInstance({
                        url: "adminapi/VipClass/upState",
                        data: {
                            status,
                            id:class_id,
                            vip_card_id,
                        },
                    }).then((res: any) => {
                        if (res.status != 202) {
                            tableData.value[0].status = status;
                        }
                    });
                }
            },
			vipClassParts = (data: any) => {
				Router.push({
					path: '/operate/vipClassParts',
					query: {
						vip_card_id: vip_card_id,
						vip_class_id:data.id,
						}
				})
			},
            handleSizeChange = (value: number): void => {
                pageSize.value = value;
                getVipCardList();
            },
            handleCurrentChange = (pageSize: number): void => {
                currentPage.value = pageSize;
                getVipCardList();
            },
            bonusSelectChange = (type: boolean) => {
				form.value.percentage = null;
            },
            onSubmit = () => {
                (formRef.value as any).validate((valid: boolean) => {
                    if (valid) {
                        let data = {},
                            url = "";
                        if (dialogType.value == 1) {
                            url = "adminapi/VipClass/create";
                            data = {
                                ...form.value,
                                vip_card_id,
                            };
                        } else {
                            url = "adminapi/VipClass/edit";
                            data = {
                                ...form.value,
                                vip_card_id,
                            };
                        }
                        Request.axiosInstance({
                            url,
                            data,
                        }).then((res: any) => {
                            dialogVisible.value = false;
                            if (res.status == 202) {
                                getVipCardList();
                            }
                        });
                    }
                });
            };

        onMounted(() => {
			vip_card_id = Route.query.vip_card_id;
			getVipCardList();
        });

        return {
            headClass,
            form,
            formRef,
            rules,
            dialogType,
            dialogVisible,
            edit,
            add,
            tableData,
            setVipCardClassState,
            onSubmit,
            loading,
            user,
            vipClassParts,
            commissionType,
            bonusSelectChange,
            handleSizeChange,
            handleCurrentChange,
            total,
            pageSize,
            currentPage
        };
    },
});
